import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

export default function SocialProof() {
  const { t } = useLanguage();
  const stats = t("social.stats");

  return (
    <section data-testid="social-proof-section" className="relative py-24 md:py-32 border-y border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="block font-mono text-xs tracking-[0.25em] text-neutral-500 mb-16 text-center"
        >
          {t("social.overline")}
        </motion.span>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {Array.isArray(stats) && stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="text-center"
            >
              <div className="font-outfit font-bold text-4xl md:text-5xl text-white mb-2">
                {stat.value}
              </div>
              <div className="font-manrope text-sm text-neutral-500">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 flex items-center justify-center gap-6 md:gap-20 opacity-30 overflow-hidden flex-wrap">
          {["TechNova", "Meridian", "Axiom", "Vanguard", "Prism"].map((name, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 + i * 0.1 }}
              className="font-outfit font-light text-xs md:text-base tracking-widest text-white/40 uppercase"
            >
              {name}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
